import React from 'react'
import './loaderStyle.css'
const Loader = () => {
  return (
    <div className="loader">
  <div></div>
  <div></div>
  <div></div>
  <div></div>
</div>
  )
}

export default Loader